import { SQL_DATABASE_CATALOG } from '@/features/sql-sync';
import { useQuerySteps } from '../../new/use-query-steps';
import { useSqlImportDetail } from '../context';
import { useDraftEdits } from '../use-draft-edits';
import { useQueryTabGuard } from './use-query-tab-guard';
import { useSaveQuery } from './use-save-query';

/**
 * What the Query and Relationship Query tabs share: the import's draft under edit, the wizard's
 * query-step state over it (previews, gating, the relationship), the `update_query` save, and
 * the unsaved-changes prompt.
 */
export function useEditableQuery() {
  const detail = useSqlImportDetail();
  const { workspaceId, type, sqlImportId, sqlImport, objectTypes, syncTarget, isDeleted } = detail;
  const edits = useDraftEdits(sqlImport);
  const steps = useQuerySteps({
    workspaceId: Number(workspaceId),
    type,
    databaseTypeName: SQL_DATABASE_CATALOG[type].name,
    syncTarget,
    draft: edits.draft,
    savedId: sqlImportId,
    objectTypes,
    setDraftFields: edits.setDraftFields,
    // There is no next step here; a timeout override only unlocks Save.
    advance: () => undefined,
  });
  const { save, isSaving } = useSaveQuery({ workspaceId: Number(workspaceId), sqlImportId, onSaved: edits.markSaved });
  useQueryTabGuard({ hasUnsavedChanges: () => !isDeleted() && edits.hasUnsavedChanges(), onDiscard: edits.reset });

  return { detail, edits, steps, save, isSaving };
}
